import React from "react";
import { AiFillInstagram, AiFillLinkedin, AiFillGithub } from "react-icons/ai";

const Hero = () => {
  return (
    <div className=" dark:text-[#E0E2DB] lg:flex mb-10 ">
      <div className="flex items-center">
        <div className=" text-center  md:p-10 ">
          <h1 className="text-2xl">Hi I'm Bounedjar Faical</h1>
          <h2 className="  text-[#511730] dark:text-[#e6af2e] text-4xl font-bold py-2">
            Software Engineer & Web Developer.
          </h2>
          <p className="py-5  text-slate-800 dark:text-[#E0E2DB]">
            I'm a Software Engineer with a strong foundation in web development
            using JS, React, Node.js, and Express. Proficient in crafting cool
            UIs with Tailwind CSS and have additional knowledge in PHP and
            Python.
          </p>
        </div>
      </div>
      <div className="flex justify-center">
        <img
          className="rounded-full bg-cover lg:w-[400px] lg:h-[350px] md:w-[350px] md:h-[350px] object-cover shadow-2xl border"
          src="/image/image.jpg"
          alt="myphoto"
        />
      </div>
      <div className=" flex md:ml-10 lg:flex-col mt-5 items-center text-slate-700 dark:text-[#E0E2DB]  text-5xl gap-16 justify-center pb-5 ">
        <a
          className="items-cecnter hover:text-purple-700 "
          href="https://www.instagram.com/faical.visuals"
        >
          <AiFillInstagram />
        </a>
        <a
          className="items-cecnter hover:text-blue-700"
          href="https://www.linkedin.com/in/bounedjarfaical"
        >
          <AiFillLinkedin />
        </a>
        <a
          className="items-cecnter hover:text-gray-900 dark:hover:text-gray-600"
          href="https://github.com/faicalbounedjar"
        >
          <AiFillGithub />
        </a>
      </div>
    </div>
  );
};

export default Hero;
